
export default async function APIRequest(details) {

        var formBody = [];
        for (var property in details) {
          var encodedKey = encodeURIComponent(property);
          var encodedValue = encodeURIComponent(details[property]);
          formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");
        var response = await fetch(process.env.REACT_APP_API_URL || '/api/api.php', {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formBody,
          credentials: 'include',
        });
        // console.log(response);
        var body = await response.json();
    return body;
}